module.exports = __webpack_public_path__ + "static/media/gif2.2a365283.gif";